// src/utils/markdown.js
export function parseMessage(message) {
    if (!message) return '';
    
    // Убеждаемся, что message является строкой
    const messageStr = String(message);
    
    // Заменяем **текст** на <strong>текст</strong>
    return messageStr.replace(/\*(.*?)\*/g, '<strong>$1</strong>');
}

export function formatNumber(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}